import React from "react";
import PropType from "prop-types";
import { ButtonContainer, LinkContainer } from "./ActionButton.styled";
import { PAGES } from "constants/pages";
import { useNavigate } from "react-router-dom";

const ActionButton = (props) => {
  const navigate = useNavigate();

  function handleClick() {
    if (props.to) {
      navigate(props.to);
    } else if (typeof props.onClick === "function") {
      props.onClick();
    }
  }
  return props.isLink ? (
    <LinkContainer
      style={props.style}
      disabled={props.disabled}
      $maxWidth={props.maxWidth}
      $color={props.color}
      to={props.to || PAGES.CONTACT.route}
      smooth={true}
      $marginTop={props.marginTop}
      $width={props.width}
      $height={props.height}
      $padding={props?.padding}
      $font={props.font}
      $iconSize={props.iconSize}
    >
      {props.children}
    </LinkContainer>
  ) : (
    <ButtonContainer
      style={props.style}
      type={props.type}
      $color={props.color}
      disabled={props.disabled}
      onClick={handleClick}
      maxWidth={props.maxWidth}
      $padding={props?.padding}
      $width={props.width}
      $height={props.height}
      $font={props.font}
      $iconSize={props.iconSize}
    >
      {props.children}
    </ButtonContainer>
  );
};

ActionButton.propTypes = {
  children: PropType.node,
  textTransform: PropType.oneOf(["uppercase", "capitalize"]),
  size: PropType.oneOf(["sm", "md", "lg", "xl"]),
  color: PropType.oneOf(["yellow", "dark"]),
  authButton: PropType.bool,
  variant: PropType.string,
  type: PropType.oneOf(["button", "submit", "reset"]),
  onClick: PropType.func,
  className: PropType.string,
  disabled: PropType.bool,
  minWidth: PropType.oneOf(["auto"]),
  hidden: PropType.bool,
  maxWidth: PropType.string,
  isLink: PropType.bool,
  marginTop: PropType.string,
  padding: PropType.string,
  to: PropType.string,
  width: PropType.string,
  height: PropType.string,
  font: PropType.string,
  iconSize: PropType.string,
  style: PropType.object,
};

ActionButton.defaultProps = {
  type: "button",
  isLink: false,
  color: "yellow",
};

export default ActionButton;
